import { useState } from 'react';
import { jokeStreams } from '@/mocks/memes';
import SectionHeader from './SectionHeader';

const kinds = ['全部', '神评论', '段子', '二创脑洞'] as const;
const kindStyle: Record<string, string> = {
  神评论: 'bg-accent-100 text-accent-800',
  段子: 'bg-secondary-100 text-secondary-900',
  二创脑洞: 'bg-primary-100 text-primary-700',
};

export default function Jokes() {
  const [kind, setKind] = useState<(typeof kinds)[number]>('全部');
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const list = kind === '全部' ? jokeStreams : jokeStreams.filter((j) => j.kind === kind);
  const toggle = (id: string) => setLiked((s) => ({ ...s, [id]: !s[id] }));

  return (
    <section id="jokes" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          kicker="💬 热梗高能弹幕"
          title="段子神评 & 网友二创"
          desc="同一场瓜，网友的嘴永远比你的好笑。高能弹幕实时滚动，二创脑洞承包今天的好心情。"
        />

        <div className="mb-8 flex flex-wrap items-center justify-center gap-2">
          {kinds.map((k) => (
            <button
              key={k}
              type="button"
              onClick={() => setKind(k)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition-colors ${
                kind === k ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-700 hover:bg-primary-100'
              }`}
            >
              {k}
              {k !== '全部' && <span className={`rounded-full px-1.5 text-xs ${kindStyle[k]}`}>{jokeStreams.filter((j) => j.kind === k).length}</span>}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2" key={kind}>
          {list.map((j) => (
            <article key={j.id} className="animate-pop rounded-3xl bg-background-50 p-5 ring-1 ring-background-200 md:p-6">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-accent-400 to-accent-600 text-lg text-background-50">
                    <i className="ri-account-circle-line text-xl"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{j.name}</p>
                    <p className="text-xs text-foreground-400">{j.time}</p>
                  </div>
                </div>
                <span className={`rounded-full px-3 py-1 text-xs font-bold ${kindStyle[j.kind]}`}>{j.kind}</span>
              </div>
              <p className="mt-4 text-[15px] leading-relaxed text-foreground-800">{j.content}</p>
              <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3.5 text-xs text-foreground-400">
                <button
                  type="button"
                  onClick={() => toggle(j.id)}
                  className={`inline-flex items-center gap-1.5 font-semibold transition-colors ${
                    liked[j.id] ? 'text-primary-500' : 'hover:text-primary-600'
                  }`}
                >
                  <i className={`${liked[j.id] ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'} text-base`}></i>
                  {(Number(j.likes.replace('万', '')) + (liked[j.id] ? 0.1 : 0)).toFixed(1)}万
                </button>
                <span className="inline-flex items-center gap-1.5"><i className="ri-chat-3-line text-base"></i>{j.replies}回复</span>
                <span className="ml-auto inline-flex items-center gap-1 text-primary-600"><i className="ri-share-forward-line"></i>转发吃瓜</span>
              </div>
            </article>
          ))}

          {/* 整活 CTA */}
          <article className="flex flex-col justify-between rounded-3xl bg-gradient-to-br from-primary-500 to-primary-600 p-6 text-background-50 md:p-7">
            <div>
              <span className="rounded-full bg-background-50/20 px-3 py-1 text-xs font-bold">🎨 你也来整活</span>
              <h3 className="mt-4 font-heading text-2xl leading-snug">神图不如你的脑洞？<br />把你的二创甩过来</h3>
              <p className="mt-3 text-sm leading-relaxed text-background-50/85">
                自己做的表情包、改编的梗图、热评神回复都能投稿。一经选用，会在“每日看瓜”展示并署上你的昵称，冲上“二创达人”榜。
              </p>
            </div>
            <a
              href="#contact"
              className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-3 text-sm font-bold text-primary-700 transition-transform hover:-translate-y-0.5"
            >
              立即投稿 <i className="ri-send-plane-line"></i>
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}